import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";

export const useCreateBranch = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: {
            name: string;
            address: string;
            phone: string;
        }) => adminApi.createBranch(data),

        onSuccess: () => {
            // Tự động gọi lại API getAllBranch
            queryClient.invalidateQueries({
                queryKey: ["branches"],
            });
        },
    });
};
